var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCloseNotification(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCloseNotification") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M336.660801,30.2213333 L339.057398,27.8247359 C339.459543,27.4225912 339.457411,26.7802516 339.059913,26.3827537 C338.659644,25.9824844 338.016818,25.9863816 337.617931,26.3852685 L335.221333,28.781866 L332.824736,26.3852685 C332.422591,25.9831238 331.780252,25.9852557 331.382754,26.3827537 C330.982484,26.7830229 330.986382,27.425849 331.385268,27.8247359 L333.781866,30.2213333 L331.385268,32.6179308 C330.983124,33.0200755 330.985256,33.6624151 331.382754,34.059913 C331.783023,34.4601822 332.425849,34.456285 332.824736,34.0573982 L335.221333,31.6608007 L337.617931,34.0573982 C338.020075,34.4595429 338.662415,34.4574109 339.059913,34.059913 C339.460182,33.6596438 339.456285,33.0168176 339.057398,32.6179308 L336.660801,30.2213333 Z M335.5,40 C330.253295,40 326,35.7467051 326,30.5 C326,25.2532949 330.253295,21 335.5,21 C340.746705,21 345,25.2532949 345,30.5 C345,35.7467051 340.746705,40 335.5,40 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Quick-reply-Copy",
    transform: "translate(-332.000000, -93.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Notification",
    transform: "translate(6.000000, 72.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icCloseNotification",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseNotification);
export default __webpack_public_path__ + "static/media/icCloseNotification.a1fe6e27bb0e1dd84853cabb8282da3c.svg";
export { ForwardRef as ReactComponent };